import React, { useEffect, useState } from 'react';
import './MiCuentaPageDetails.css';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';


function MiCuentaPageDetails() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { userId, logout, role } = useAuth(); // Asegúrate que `userRole` esté disponible
  const navigate = useNavigate();
  
  useEffect(() => {
    if (role === 'sponsor') {
      navigate('/mis-eventos');
    }
  }, [role, navigate]);


  useEffect(() => {
    if (!userId) {
      setError("No se pudo obtener el ID del usuario.");
      setLoading(false);
      return;
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/orders/user/${userId}`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Error al obtener órdenes: ${response.statusText}`);
        }
        return response.json();
      })
      .then(data => {
        setOrders(data);
        setLoading(false);
      })
      .catch(error => {
        setError(error.message);
        setLoading(false);
      });

  }, [userId]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('es-ES');
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  return (
    <div className="account-overview-container">
      <header className="account-header">
        <button className="logout-button" onClick={handleLogout}>
          Cerrar Sesión
        </button>
      </header>
      <div className="account-content">
        <aside className="account-menu">
          <button>Información De La Cuenta</button>
          <button>Cambiar Contraseña</button>
          <button>Órdenes</button>
        </aside>
        <section className="recent-orders">
          <h2>Órdenes recientes</h2>
          {loading ? (
            <p>Cargando órdenes...</p>
          ) : error ? (
            <p className="error-message">{error}</p>
          ) : orders.length > 0 ? (
            <>
              {/* Vista de tabla para escritorio */}
              <div className="orders-table-desktop">
                <table>
                  <thead>
                    <tr>
                      <th>Orden #</th>
                      <th>Fecha</th>
                      <th>SubTotal</th>
                      <th>Cargo Manejo</th>
                      <th>Total</th>
                      <th>Estatus</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map(order => (
                      <tr key={order.id}>
                        <td>{order.id}</td>
                        <td>{formatDate(order.createdAt)}</td>
                        <td>${order.totalPrice.toFixed(2)}</td>
                        <td>${order.totalGlobalCharge.toFixed(2)}</td>
                        <td>${(order.totalGlobalCharge + order.totalPrice).toFixed(2)}</td>
                        <td>{order.status}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Vista de tarjetas para móvil */}
              <div className="orders-cards-mobile">
                {orders.map(order => (
                  <div className="order-card" key={order.id}>
                    <p><strong>Orden #:</strong> {order.id}</p>
                    <p><strong>Fecha:</strong> {formatDate(order.createdAt)}</p>
                    <p><strong>SubTotal:</strong> ${order.totalPrice.toFixed(2)}</p>
                    <p><strong>Cargo Manejo:</strong> ${order.totalGlobalCharge.toFixed(2)}</p>
                    <p><strong>Total:</strong> ${(order.totalGlobalCharge + order.totalPrice).toFixed(2)}</p>
                    <p><strong>Estatus:</strong> {order.status}</p>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <p>No hay órdenes recientes.</p>
          )}
          <button className="all-orders-button">Todas Las Órdenes</button>
        </section>
      </div>
    </div>
  );
}

export default MiCuentaPageDetails;
